module.exports = __webpack_public_path__ + "img/bg_sec8_txt.9c4aef2b.png";